module.exports = __webpack_public_path__ + "img/GainLuck.d86bdd1d.png";